<template>
  <article class="people-article" v-bind:class="{ 'reverse_position': isReverse }">
    <div class="text-wrap">
      <div class="text-inner" v-html="text">
      </div>
    </div>
    <div class="photo">
      <img :src="image" alt="">
    </div>
  </article>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'people-article',
  props: {
    isReverse: Boolean,
    text: String,
    image: String,
  }
}
</script>

<style lang="scss" scoped>
.people-article {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 100px;
  position: relative;
  // @media print, screen and (min-width: 1161px) {
  @media print, screen and (min-width: 769px) {
    display: flex;
  }
  &:nth-child(odd) {
    flex-direction: row-reverse;
    .text-wrap {
      // @media print, screen and (min-width: 1161px) {
      @media print, screen and (min-width: 769px) {
        transform: translateX(-100px);
      }
    }
    &:after {
      left: -20%;
      right: unset;
    }
  }
  &:after {
    content: "";
    width: 100%;
    height: 300px;
    display: block;
    background: linear-gradient(to right, #ffcf82 0%,#543194 100%);
    background-size: 200% 200%;
    animation: gradientAnime 10s ease infinite;
    position: absolute;
    transform: skewY(-20deg);
    transform-origin: right top;
    z-index: -1;
    bottom: 40%;
    right: -20%;
  }
  .text-wrap {
    background-color: #fff;
    // max-width: 740px;
    width: 100%;
    margin: 0 auto;
    // @media print, screen and (min-width: 1161px) {
    @media print, screen and (min-width: 769px) {
      transform: translateX(100px);
      padding: 50px;
      display: inline-block;
      margin-top: 100px;
    }
    // @media print, screen and (max-width: 1160px) {
    @media print, screen and (max-width: 768px) {
      width: 90%;
      padding: 10px 0;
    }
  }
  .text-inner {
    width: 100%;
    margin: 0 auto;
    // @media print, screen and (min-width: 1161px) {
    @media print, screen and (min-width: 769px) {
      max-width: 600px;
    }
    // @media print, screen and (max-width: 1160px) {
    @media print, screen and (max-width: 768px) {
      width: 90%;
    }
  }
}
.text-inner ::v-deep .catch {
  font-size: 24px;
  font-family: 'Noto Serif JP', serif;
}
.text-inner ::v-deep .body {
  font-size: 12px;
  i {
    font-style: normal;
    background: linear-gradient(transparent 50%, #ffcf82 50%); 
  }
}
.photo {
  width: 100%;
  // @media print, screen and (min-width: 1161px) {
  @media print, screen and (min-width: 769px) {
    max-width: 480px;
  }
}
.reverse_position {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 100px;
  position: relative;
  // @media print, screen and (min-width: 1161px) {
  @media print, screen and (min-width: 769px) {
    display: flex;
  }
  &:nth-child(odd) {
    flex-direction: row;
    .text-wrap {
      // @media print, screen and (min-width: 1161px) {
      @media print, screen and (min-width: 769px) {
        transform: translateX(100px);
      }
    }
    &:after {
      right: -20%;
    }
  }
  &:nth-child(even) {
  flex-direction: row-reverse;
    .text-wrap {
      // @media print, screen and (min-width: 1161px) {
      @media print, screen and (min-width: 769px) {
        transform: translateX(-100px);
      }
    }
    &:after {
      left: -20%;
    }
  }
}
</style>